import React, { useEffect, useState } from 'react';
import { ShieldCheck, ShieldAlert } from 'lucide-react';
import { superadminApi } from '../lib/api';
import { formatDateGB } from '../lib/dates';

/**
 * Superadmin → Trials: "sign-ups blocked in the last 30 days, and why" (Group A7, Rob
 * 21/10/2026). The number that says whether a captcha is ever needed — Cloudflare
 * Turnstile is parked until this stops being (nearly) zero. No personal data behind it:
 * the server keeps a reason and a time per refusal, nothing else.
 */
const SignupBlocksCard = () => {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    superadminApi.getSignupBlocks().then((r) => setData(r.data)).catch(() => setFailed(true));
  }, []);

  if (failed) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 text-sm text-muted-foreground" data-testid="signup-blocks">
        Couldn't load the blocked sign-ups count.
      </div>
    );
  }
  if (!data) return null;

  const Icon = data.total > 0 ? ShieldAlert : ShieldCheck;
  return (
    <div className="bg-card border border-border rounded-lg p-6" data-testid="signup-blocks">
      <h3 className="font-heading font-semibold mb-1 flex items-center gap-2">
        <Icon className={`w-4 h-4 ${data.total > 0 ? 'text-amber-600' : 'text-emerald-600'}`} />
        Sign-ups blocked as bots: <span data-testid="signup-blocks-total">{data.total}</span> in the last {data.days} days
      </h3>
      <p className="text-sm text-muted-foreground mb-3">
        Sign-up refuses anything that fills in a hidden box people never see, and more than{' '}
        {data.limit_per_hour} new accounts an hour from one internet address. If this number
        starts climbing, that's the moment to add a captcha (Cloudflare Turnstile) — ask Claude.
      </p>
      <ul className="text-sm space-y-1">
        {data.by_reason.map((r) => (
          <li key={r.reason} className="flex justify-between max-w-md">
            <span className="text-muted-foreground">{r.label.charAt(0).toUpperCase() + r.label.slice(1)}</span>
            <strong>{r.count}</strong>
          </li>
        ))}
      </ul>
      {data.last_at && (
        <p className="text-xs text-muted-foreground mt-3">Most recent: {formatDateGB(data.last_at.slice(0, 10))}</p>
      )}
    </div>
  );
};

export default SignupBlocksCard;
